let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fMaAd")).then(() => parcelRequire('978Kz'));